import React from 'react'
import DropdownCol from 'components/form-elements/DropdownCol';
import DatepickerCol from 'components/form-elements/DatepickerCol';
import CheckboxCol from 'components/form-elements/CheckboxCol';
import CheckboxFormCol from 'components/form-elements/CheckboxFormCol';
import InputCol from 'components/form-elements/InputCol';
import PhotoDropUploadCol from 'components/form-elements/PhotoDropUploadCol';
import DropdownDinamisCol from 'components/form-elements/DropdownDinamisCol';
import { getByDotted } from 'utils/MyUtils';
import DatetimepickerCol from './DatetimepickerCol';
import ListCheckboxCol from './ListCheckboxCol';
import PopupChecklistCol from './PopupChecklistCol';
import DropUploadCol from './DropUploadCol';
import DropUploadMultiCol from './DropUploadMultiCol';
import InputMultiple from 'components/form-master-detail/InputMultiple';
import InputMultipleCol from 'components/form-master-detail/InputMultipleCol';
import Hidden from './Hidden';

const ItemInput = (props) => {
    const element = props
    let { type, value, label, labelinput, name, elname, validation, defaultValue, options, colsize, register, errors, setValue = () => { }, watch = () => undefined, idx, ...rest } = element
    name = name ? name : elname
    const colsz = colsize ? colsize : "3"
    const activeValue = value !== undefined ? value : watch(name)
    let ret = ""
    let myerror = errors?.[name + ""]?.message
    if (myerror === undefined) {
        const errel = getByDotted(errors, name + "")
        if (errel) {
            myerror = errel?.message
        }
    }
    switch (element?.type) {
        case "hidden":
            ret = <Hidden name={name} setValue={setValue} value={value !== undefined ? value : defaultValue?.[name]} ></Hidden>
            break;
        case "money":
        case "number":
        case "email":
        case "text":
            ret = <InputCol key={"formel-" + idx} type={type} colsize={colsz} {...rest} name={name} error={myerror} register={register} validation={validation} label={label} setValue={setValue} />
            break;
        case "textarea":
            ret = (
              <InputCol
                key={"formel-" + idx}
                colsize={colsz}
                {...rest}
                as="textarea"
                name={name}
                error={myerror}
                register={register}
                validation={validation}
                label={label}
                setValue={setValue}
              />
            )
            break;
        case "password":
            ret = <InputCol type="password" key={"formel-" + idx} colsize={colsz} {...rest} name={name} error={myerror} register={register} validation={validation} label={label} setValue={setValue} />
            break;
        case "dropdown":
            ret = name && <DropdownCol
                colsize={colsz}
                name={name}
                error={myerror}
                register={register}
                validation={validation}
                label={label}
                options={options}
                setValue={setValue}
                {...rest}
                key={"formel-" + idx}
                defaultValue={defaultValue}
            />
            break;
        case "dropdowndinamis":
            ret = name && <DropdownDinamisCol
                colsize={colsz}
                name={name}
                value={activeValue}
                error={myerror}
                register={register}
                validation={validation}
                label={label}
                options={options}
                setValue={setValue}
                {...rest}
                key={"formel-" + idx}
                defaultValue={defaultValue}
            />
            break;
        case "date":
            ret = <DatepickerCol key={"formel-" + idx} value={activeValue ?? defaultValue?.[name]} {...rest} colsize={colsz} name={name} error={myerror} register={register} setValue={setValue} validation={validation} label={label} />
            break;
        case "datetime":
            ret = <DatetimepickerCol key={"formel-" + idx} value={activeValue ?? defaultValue?.[name]} {...rest} colsize={colsz} name={name} error={myerror} register={register} setValue={setValue} validation={validation} label={label} />
            break;
        case "checkbox":
            ret = <CheckboxCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} error={myerror} register={register} validation={validation} label={label} setValue={setValue} />
            break;
        case "checkboxform":
            ret = <CheckboxFormCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} error={myerror} register={register} validation={validation} label={label} setValue={setValue} />
            break;
        case "divider":
            ret = (
              <div
                style={{
                  clear: 'left',
                  display: 'block',
                  width: '100%',
                  marginLeft: '8px',
                  marginRight: '8px',
                  marginTop: '8px',
                  marginBottom: '8px',
                }}
              >
                {label && (
                  <div style={{ fontWeight: 600, marginBottom: 6 }}>
                    {label}
                  </div>
                )}
                <div style={{ borderTop: '1px solid #CCCCCC', width: '100%' }} />
              </div>
            )
            break;
        case "listcheckbox":
            ret = <ListCheckboxCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} error={myerror} register={register} label={label} setValue={setValue} defaultValue={defaultValue} />
            break;
        case "popupchecklist":
            ret = <PopupChecklistCol key={"formel-" + idx} {...rest} colsize={colsz} name={name} value={activeValue} watch={watch} error={myerror} register={register} validation={validation} label={label} setValue={setValue} defaultValue={defaultValue} />
            break;
        case "filedrop":
            let lbl = labelinput ? labelinput : label
            lbl = props?.placeholder ? props?.placeholder : lbl
            ret = <DropUploadCol key={"formel-" + idx} {...rest} value={activeValue ?? defaultValue?.[name]} colsize={colsz} name={name} label={lbl} error={myerror} register={register} validation={validation} setValue={setValue} />
            break;
        case "photodrop":
            ret = (
                <PhotoDropUploadCol
                    key={"formel-" + idx}
                    {...rest}
                    value={activeValue ?? defaultValue?.[name]}
                    colsize={colsz}
                    name={name}
                    label={label}
                    error={myerror}
                    register={register}
                    validation={validation}
                    setValue={setValue}
                />
            )
            break;
        case "inputdetail":
            ret = <InputMultipleCol key={"formel-" + idx} defaultValue={defaultValue} {...rest} errors={errors} colsize={colsz} name={name} label={label} error={myerror} register={register} validation={validation} setValue={setValue} />
            break;
        default:
            break;
    }
    return props && ret
}

export default ItemInput
